import { defineBoot } from '@quasar/app-vite/wrappers';
import store from 'src/store';

/**
 * Search related boot actions.
 */
export default defineBoot(({ router }) => {
  router.beforeEach(async ({ matched }, { matched: oldMatched }, next) => {
    // Update the search priority
    const [route] = matched || [];
    store().dispatch('search/setSearchPriority', route?.meta?.searchPriority);

    if (!store().state.filtering.filtersInitialized) {
      // Do nothing until filters are initialized
      next();
      return;
    }

    const rootPath = matched?.[0]?.path;
    const previousRootPath = oldMatched?.[0]?.path;

    if (rootPath !== previousRootPath && rootPath !== '') {
      // Clear Universal Search filters before transitioning to a new route
      await store().dispatch('filtering/filterByTerm', '', { root: true });
      await store().dispatch('search/updateFilterTerms', '', { root: true });
    }

    next();
  });
});
